import React from "react";
import styled, { keyframes } from "styled-components";
import { rem } from "polished";
import colors from "../../../utils/colors";
import { Localize } from "../../../locale/localization";
import TagListCard from "./TagListCard";
import { media } from "../../../utils/uiSizes";

const fadeInAnim = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const CardWrap = styled.div`
  background-color: ${colors.BRAND_RED_LIGHT};
  border-radius: 0.3125rem;
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.5217391304348%;

  &.pinned {
    ${media.tablet`
      padding-top: 43.8297872340426%;
    `};
  }

  box-shadow: 1px 3px 10px 0 rgba(0, 0, 0, 0.2);

  animation-name: ${fadeInAnim};
  animation-duration: 0.66s;
  animation-timing-function: ease-out;
`;

const CardBackground = styled.figure`
  background: linear-gradient(${colors.BRAND_RED_LIGHT} 19%, ${colors.BRAND_RED} 100%);
  ${props =>
    props.src &&
    `
    background-image: url(${props.src});
    background-position: 50% 50%;
    background-size: cover;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: linear-gradient(rgba(0,0,0,0.0) 32%, rgba(0,0,0,0.4) 82%);
    }
  `} &:hover {
    &:after {
      background-image: linear-gradient(rgba(0, 0, 0, 0) 32%, rgba(0, 0, 0, 0.15) 82%);
    }
  }
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

const CardContent = styled.div`
  color: white;
  position: absolute;
  bottom: 0;
  z-index: 1;
  padding: 1.875rem 1.625rem 0.375rem 1.625rem;
  box-sizing: border-box;
`;

const CardSubTitle = styled.h6`
  font-family: "FyranSans-Core";
  font-size: 14px;
  line-height: 14px;
  font-weight: 400;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.109375rem;

  span {
    font-size: ${rem("13px")};
    display: inline-block;
    padding-right: 0.25rem;
    color: ${colors.WHITE };
  }
`;

const CardTitle = styled.h5`
  font-family: "FyranSans-SemiBold";
  font-size: 22px;
  font-weight: 600;
  line-height: 25.96px;
  margin-bottom: 0.5rem;
`;

const Card = props => {
  const {
    Container = "div",
    className = "",
    background,
    subTitle,
    title,
    tags,
    pinned,
    type
  } = props;
  const typeName = type === "news" ? "" : Localize("inner-circle");

  return (
    <Container className={className}>
      <CardWrap className={pinned && "pinned"}>
        <CardBackground src={background} />
        <CardContent>
          <CardSubTitle>
            {typeName !== "" && <span>{typeName}: </span>}
            {subTitle}
          </CardSubTitle>
          <CardTitle>{title}</CardTitle>
          <TagListCard tags={tags} />
        </CardContent>
      </CardWrap>
    </Container>
  );
};

export default Card;



// WEBPACK FOOTER //
// ./src/modules/common/components/Card.js